module.exports = __webpack_public_path__ + "static/media/skincarepro_v1_dk_8report.47c0c85c.png";